/*
Documentation

*** make sure to declare all action types in actions.js one folder level back

*/

import * as actionTypes from '../../actions';

const initialState = {
    divisions: [],
}

const reducer = (state = initialState, action) => {

    switch (action.type) {

        case actionTypes.SET_DIVISIONS:

            return {
                ...state,
                divisions: action.payload.data,
            }

        default: return state;

    }

}

export default reducer;
